import { useLocalStorage } from "@pmag/ui-components";
import { useAttributeConfig } from "@src/hooks/useAttributeConfig";
import * as yup from "yup";

export const useWishlist = () => {
    const { wishlistClientside } = useAttributeConfig();
    const [wishlist, setWishlist] = useLocalStorage<string[]>("spfWishlist", [], yup.array().of(yup.string().required()).required());

    const addToWishList = (wishlistEntry: string) => {
        if (!wishlist.includes(wishlistEntry)) {
            setWishlist([wishlistEntry, ...wishlist]);
        }
    };

    const removeFromWishList = (wishlistEntry: string) => {
        setWishlist(wishlist.filter((item) => item !== wishlistEntry));
    };

    const removeAllFromWishList = () => setWishlist([]);

    return {
        wishlist: wishlistClientside ? [] : wishlist,
        addToWishList,
        removeFromWishList,
        removeAllFromWishList,
    };
};
